export const CONFIG = {
  thresholds: {
    minOcrConfidence: 15,
    physicalDocumentConfidence: 50,
    highTrustConfidence: 75,
    strictMatching: true,
  },
  engine: {
    defaultLanguage: "eng",
    contrastLevel: 1.8,
    preprocessEnabled: true,
    fallbackProfile: "global_standard",
  },
  kyc: {
    requireDualSide: true,
    allowManualOverride: false,
  },
};
